module.exports = __webpack_public_path__ + "static/favicon-245b4827e04d3bbceec342ad51dd9d7c.ico";